module.exports = __webpack_public_path__ + "img/map_bus_icon.83f2b552.svg";